import { useState } from "react";
import styled from "styled-components";
import { Input } from "../../../../components/Input/input";
import { theme } from "../../../../helpers/theme";
import { StyledPopover } from "./styled-popover";

interface StoragePopoverProps {
  storageElement: string;
  setStorageElement: (element: string) => void;
}

const StoragePopover = ({
  storageElement,
  setStorageElement,
}: StoragePopoverProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLocationClick = (item: string) => {
    setStorageElement(item);
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const options = ["Składowanie", "Crossdocking", "Fullfilment"];
  return (
    <StoragePopoverContainer>
      {" "}
      <Input
        label="Czego szukasz?"
        id="storage"
        name="storage"
        value={storageElement}
        onClick={(e) => handleClick(e)}
        focused={false}
        variant="filled"
        style={{ width: "100%", caretColor: "transparent" }}
      />
      <StyledPopover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <PopoverContentContainer>
          <LocationWrapper>
            {options.map((item) => (
              <LocationItem
                key={item}
                onClick={() => handleLocationClick(item)}
              >
                {item}
              </LocationItem>
            ))}
          </LocationWrapper>
        </PopoverContentContainer>
      </StyledPopover>
    </StoragePopoverContainer>
  );
};

export default StoragePopover;

const StoragePopoverContainer = styled.div`
  width: 18%;
  display: flex;
  align-items: center;
  height: 100%;
  border-right: 1px solid ${theme.colors.gray04_background};
`;
const PopoverContentContainer = styled.div`
  padding: 20px;
  width: 377px;
  height: 45px;
  background-color: white;
`;
const LocationWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;
const LocationItem = styled.div`
  cursor: pointer;
  padding: 12px;
  display: flex;
  justify-content: center;
  font-family: ${theme.fonts.interMedium};
  border: 1px solid ${theme.colors.gray02_border};
  border-radius: 10px;
  :hover {
    border: 1px solid ${theme.colors.blue02_hover};
  }
`;
const LocationName = styled.span`
  font-family: ${theme.fonts.interMedium};
  cursor: pointer;
  margin-left: 2px;
`;
